import { useQueries } from '@tanstack/react-query';
import { fetchAuditLog } from 'services/journeys';
import { geofenceEventsOf } from 'util/geofenceEvents';

export {
  GEOFENCE_ACTION,
  GEOFENCE_RADIUS_METERS,
  geofenceEventsOf,
} from 'util/geofenceEvents';
export type { GeofenceEvent } from 'util/geofenceEvents';

export const useCollectionGeofenceEvents = (
  collectionId: number | undefined,
  journeyIds: string[],
  enabled = true,
) => {
  const results = useQueries({
    queries: journeyIds.map((journeyId) => ({
      queryKey: ['auditLog', journeyId],
      queryFn: () => fetchAuditLog(journeyId),
      enabled: enabled && !!collectionId,
      retry: 1,
    })),
  });

  const events = collectionId
    ? journeyIds.flatMap((journeyId, index) =>
        geofenceEventsOf(results[index]?.data, journeyId, collectionId),
      )
    : [];

  events.sort((a, b) => (a.occurredAt ?? '').localeCompare(b.occurredAt ?? ''));

  const failedJourneys = journeyIds.filter(
    (_journeyId, index) => results[index]?.isError,
  );

  return {
    events,
    isFetching: results.some((result) => result.isFetching),
    failedJourneys,
  };
};
